// motif-builder.js

(function () {

  function init() {
    var productId     = window.__motifBuilderProductId;
    var ringCount     = window.__motifBuilderRingCount  || 1;
    var motifMax      = window.__motifBuilderMotifMax   || 3;
    var mainVariantId = window.__motifBuilderMainVariantId;

    if (!productId) return;

    var wrap = document.getElementById('motif-builder-' + productId);
    if (!wrap) return;

    var productFormEl = document.querySelector('product-form');
    if (!productFormEl) return;

    var submitBtn = productFormEl.querySelector('[type="submit"], [name="add"]');
    if (!submitBtn) return;

    // ── キャッシュ ────────────────────────────────────────
    var priceCache   = {};
    var productCache = {};

    function formatMoney(cents) {
       // Shopify標準のフォーマッタを優先
  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
    return window.Shopify.formatMoney(cents, window.__moneyFormat);
  }

  // フォールバック：Intl で通貨に応じて整形
  var code = window.__cartCurrency || 'JPY';
  try {
    return new Intl.NumberFormat(document.documentElement.lang || 'ja-JP', {
      style: 'currency',
      currency: code
    }).format(cents / 100);
  } catch (e) {
    return '¥' + Math.floor(cents / 100).toLocaleString('ja-JP');
  }
    }

    async function fetchProduct(handle) {
      if (productCache[handle]) return productCache[handle];
      try {
        var res  = await fetch('/products/' + handle + '.js');
        var data = await res.json();
        productCache[handle] = data;
        return data;
      } catch (e) {
        return null;
      }
    }

    // ── 全モチーフを事前読み込み ──────────────────────────
    async function prefetchMotifs() {
      var btns    = wrap.querySelectorAll('.motif-builder__btn');
      var handles = [];
      btns.forEach(function (btn) {
        var h = btn.dataset.motifHandle;
        if (h && handles.indexOf(h) === -1) handles.push(h);
      });
      await Promise.all(handles.map(function (h) { return fetchProduct(h); }));
    }

    // ── 選択状態の管理 ────────────────────────────────────
    var selections = { single: [], a: [], b: [] };

    // ── カウント更新 ──────────────────────────────────────
    function updateCount(ring) {
      var countEl = document.getElementById(
        ring === 'single'
          ? 'motif-count-' + productId
          : 'motif-count-' + ring + '-' + productId
      );
      if (!countEl) return;
      countEl.textContent = '（' + selections[ring].length + '/' + motifMax + '）';
    }

    // ── ボタンの活性・非活性制御 ──────────────────────────
    function updateBtns(ring) {
      var btnsEl = document.getElementById(
        ring === 'single'
          ? 'motif-btns-' + productId
          : 'motif-btns-' + ring + '-' + productId
      );
      if (!btnsEl) return;

      var isFull   = selections[ring].length >= motifMax;
      var selected = selections[ring].map(function (s) { return s.handle; });

      btnsEl.querySelectorAll('.motif-builder__btn').forEach(function (btn) {
        var alreadySelected = selected.indexOf(btn.dataset.motifHandle) !== -1;
        if (alreadySelected || isFull) {
          btn.classList.add('is-disabled');
        } else {
          btn.classList.remove('is-disabled');
        }
      });
    }

    // ── 選択済みアイテムのUI生成（差分更新） ──────────────
    async function renderSelections(ring) {
      var selectionsEl = document.getElementById(
        ring === 'single'
          ? 'motif-selections-' + productId
          : 'motif-selections-' + ring + '-' + productId
      );
      if (!selectionsEl) return;

      var existingItems = selectionsEl.querySelectorAll('.motif-builder__selection-item');
      var currentCount  = selections[ring].length;

      if (existingItems.length > currentCount) {
        selectionsEl.innerHTML = '';
        for (var i = 0; i < currentCount; i++) {
          await appendSelectionItem(ring, i, selectionsEl);
        }
      } else if (existingItems.length < currentCount) {
        await appendSelectionItem(ring, currentCount - 1, selectionsEl);
      }

      updateTotalPrice();
    }

    // ── 選択アイテムのDOM生成 ─────────────────────────────
    async function appendSelectionItem(ring, i, selectionsEl) {
      var sel  = selections[ring][i];
      var item = document.createElement('div');
      item.className       = 'motif-builder__selection-item';
      item.dataset.ring    = ring;
      item.dataset.handle  = sel.handle;
      item.dataset.index   = i;

      var header = document.createElement('div');
      header.className = 'motif-builder__selection-header';

      var titleGroup = document.createElement('div');
      titleGroup.className = 'motif-builder__selection-title-group';

      var title = document.createElement('span');
      title.className   = 'motif-builder__selection-title';
      title.textContent = (i + 1) + 'つ目：' + sel.label;

      var helpBtn = document.createElement('button');
      helpBtn.type = 'button';
      helpBtn.className = 'option-help-trigger';
      helpBtn.setAttribute('aria-haspopup', 'dialog');
      helpBtn.setAttribute('aria-label', '詳細を見る');
      helpBtn.innerHTML = '<span aria-hidden="true">？</span>';

      var removeBtn = document.createElement('button');
      removeBtn.type           = 'button';
      removeBtn.className      = 'motif-builder__selection-remove';
      removeBtn.textContent    = '✕';
      removeBtn.dataset.ring   = ring;
      removeBtn.dataset.handle = sel.handle;
      removeBtn.dataset.index  = i;

      header.appendChild(title);

      var openerId = 'HiddenOpener-motif-' + sel.handle + '-' + productId;
      var openerBtn = document.getElementById(openerId);
      if (openerBtn) {
        helpBtn.addEventListener('click', function () {
          openerBtn.click();
        });
        titleGroup.appendChild(helpBtn);
      }
      titleGroup.insertBefore(title, titleGroup.firstChild);
      header.appendChild(titleGroup);
      header.appendChild(removeBtn);
      item.appendChild(header);

      var subEl = document.createElement('div');
      subEl.className = 'motif-builder__sub-option';

      var productData = await fetchProduct(sel.handle);
      if (productData) {
        if (sel.isBirthstone) {
          // Birth Stone（Natural stone）→ セレクトボックス
          var select = document.createElement('select');
          select.className       = 'motif-builder__sub-select';
          select.dataset.ring    = ring;
          select.dataset.handle  = sel.handle;
          select.dataset.index   = i;

          var defaultOpt         = document.createElement('option');
          defaultOpt.value       = '';
          defaultOpt.textContent = '誕生石を選んでください';
          select.appendChild(defaultOpt);

          productData.variants.forEach(function (variant) {
            var opt                 = document.createElement('option');
            opt.value               = variant.id;
            opt.textContent         = (variant.option1 || variant.title) + '　' + formatMoney(variant.price);
            opt.dataset.price       = variant.price;
            opt.dataset.choiceLabel = variant.option1 || variant.title;
            priceCache[variant.id]  = variant.price;
            select.appendChild(opt);
          });

          if (sel.subVariantId) select.value = sel.subVariantId;

          select.addEventListener('change', function () {
            var idx = Number(this.dataset.index);
            selections[this.dataset.ring][idx].subVariantId = this.value;
            updateTotalPrice();
          });

          subEl.appendChild(select);

        } else {
          // 金種 → カラーボタン
          var subBtns = document.createElement('div');
          subBtns.className = 'motif-builder__sub-btns';

          productData.variants.forEach(function (variant) {
            priceCache[variant.id] = variant.price;

            var btn = document.createElement('button');
            btn.type                = 'button';
            btn.className           = 'motif-builder__sub-btn';
            btn.dataset.ring        = ring;
            btn.dataset.handle      = sel.handle;
            btn.dataset.index       = i;
            btn.dataset.variantId   = variant.id;
            btn.dataset.choiceLabel = variant.option1 || variant.title;

            if (variant.featured_image) {
              var img               = document.createElement('img');
              img.src               = variant.featured_image.src;
              img.width             = 40;
              img.height            = 40;
              img.style.borderRadius = '50%';
              img.style.objectFit   = 'cover';
              btn.appendChild(img);
            }

            var labelEl       = document.createElement('span');
            var labelText     = variant.option1 || variant.title;
            if (labelText.indexOf('(') !== -1) {
              var parts = labelText.split('(');
              labelEl.textContent = parts[0].trim();
              labelEl.appendChild(document.createElement('br'));
              var subSpan = document.createElement('span');
              subSpan.style.fontSize = '0.9em';
              subSpan.textContent = '(' + parts[1];
              labelEl.appendChild(subSpan);
            } else {
              labelEl.textContent = labelText;
            }
            btn.appendChild(labelEl);

            var priceEl            = document.createElement('span');
            priceEl.style.fontSize = '1rem';
            priceEl.style.color    = 'rgba(var(--color-foreground), 0.6)';
            priceEl.textContent    = formatMoney(variant.price);
            btn.appendChild(priceEl);

            if (sel.subVariantId == variant.id) {
              btn.classList.add('is-selected');
            }

            btn.addEventListener('click', function () {
              var idx = Number(this.dataset.index);
              this.closest('.motif-builder__sub-btns').querySelectorAll('.motif-builder__sub-btn').forEach(function (b) {
                b.classList.remove('is-selected');
              });
              this.classList.add('is-selected');
              selections[this.dataset.ring][idx].subVariantId = this.dataset.variantId;
              updateTotalPrice();
            });

            subBtns.appendChild(btn);
          });

          if (!sel.subVariantId) {
            var firstBtn = subBtns.querySelector('.motif-builder__sub-btn');
            if (firstBtn) {
              firstBtn.classList.add('is-selected');
              selections[ring][i].subVariantId = firstBtn.dataset.variantId;
            }
          }

          subEl.appendChild(subBtns);
        }
      }

      item.appendChild(subEl);
      selectionsEl.appendChild(item);
    }

    // ── 合計価格更新 ──────────────────────────────────────
    async function updateTotalPrice() {
      var total = 0;

      var variantInput = productFormEl.querySelector('form [name="id"]');
      var mainVariant  = variantInput ? variantInput.value : mainVariantId;
      if (mainVariant && priceCache[mainVariant] === undefined) {
        try {
          var res  = await fetch('/variants/' + mainVariant + '.js');
          var data = await res.json();
          priceCache[mainVariant] = data.price;
        } catch (e) {}
      }
      total += priceCache[mainVariant] || 0;

      ['single', 'a', 'b'].forEach(function (ring) {
        selections[ring].forEach(function (sel) {
          if (sel.subVariantId && priceCache[sel.subVariantId]) {
            total += priceCache[sel.subVariantId];
          }
        });
      });

      var priceEl = document.querySelector('.price__regular .price-item--regular, .price__sale .price-item--sale');
      if (priceEl) priceEl.textContent = formatMoney(total);
    }

    // ── モチーフボタンのクリック ──────────────────────────
    wrap.addEventListener('click', async function (e) {
      var btn = e.target.closest('.motif-builder__btn');
      if (btn && !btn.classList.contains('is-disabled')) {
        var ring         = btn.dataset.ring;
        var handle       = btn.dataset.motifHandle;
        var label        = (btn.dataset.motifLabel || '').replace('【オプション】', '').trim();
        var isBirthstone = btn.dataset.isBirthstone === 'true';

        if (selections[ring].length >= motifMax) return;

        selections[ring].push({
          handle:       handle,
          label:        label,
          isBirthstone: isBirthstone,
          subVariantId: null
        });

        updateCount(ring);
        updateBtns(ring);
        await renderSelections(ring);
        return;
      }

      var removeBtn = e.target.closest('.motif-builder__selection-remove');
      if (removeBtn) {
        var ring = removeBtn.dataset.ring;
        var idx  = Number(removeBtn.dataset.index);
        selections[ring].splice(idx, 1);
        updateCount(ring);
        updateBtns(ring);
        await renderSelections(ring);
        return;
      }
    });

    // ── カートボタンのclickを乗っ取る ────────────────────
    submitBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      handleAddToCart();
    }, true);

    // ── カート追加処理 ────────────────────────────────────
    async function handleAddToCart() {
      var originalText = submitBtn.textContent.trim();

      var errors = [];

      ['single', 'a', 'b'].forEach(function (ring) {
        var btnsEl = document.getElementById(
          ring === 'single'
            ? 'motif-btns-' + productId
            : 'motif-btns-' + ring + '-' + productId
        );
        if (!btnsEl) return;

        var ringLabel = ring === 'single' ? '' : 'RING ' + ring.toUpperCase() + ' ';

        if (selections[ring].length < motifMax) {
          var countEl = document.getElementById(
            ring === 'single'
              ? 'motif-count-' + productId
              : 'motif-count-' + ring + '-' + productId
          );
          if (countEl) countEl.style.color = 'red';
          errors.push(ringLabel + 'モチーフを' + motifMax + 'つ選んでください');
        }

        selections[ring].forEach(function (sel, idx) {
          if (!sel.subVariantId) {
            errors.push(ringLabel + (idx + 1) + 'つ目「' + sel.label + '」の詳細を選択してください');
          }
        });
      });

      var ringBSize = document.getElementById('ring-b-size-' + productId);
      if (ringBSize && !ringBSize.value) {
        errors.push('RING B のサイズを選択してください');
      }

      if (errors.length > 0) {
        alert(errors.join('\n'));
        return;
      }

      submitBtn.disabled    = true;
      submitBtn.textContent = '追加中…';

      var variantInput = productFormEl.querySelector('form [name="id"]');
      var variantId    = variantInput ? variantInput.value : mainVariantId;
      var bundleId     = 'bundle_' + Date.now();
      var items        = [];

      var mainProps = {
        _bundle_id: bundleId,
        _is_main:   'true'
      };

      var ringBSize = document.getElementById('ring-b-size-' + productId);
      if (ringBSize && ringBSize.value) {
        mainProps['RING B サイズ'] = ringBSize.value;
      }

      ['single', 'a', 'b'].forEach(function (ring) {
        selections[ring].forEach(function (sel, idx) {
          var prefix = ring === 'single' ? '' : 'RING ' + ring.toUpperCase() + ' ';
          mainProps[prefix + (idx + 1) + 'つ目'] = sel.label;
        });
      });

      items.push({
        id:         Number(variantId),
        quantity:   1,
        properties: mainProps
      });

      var customWrap = document.getElementById('custom-builder-' + productId);
      if (customWrap) {
        var toggleLabels = {};
        customWrap.querySelectorAll('.custom-builder__opt-btn[data-type="toggle"]').forEach(function (btn) {
          var label = btn.dataset.label;
          if (!label) return;
          toggleLabels[label] = toggleLabels[label] || { optionIndex: btn.dataset.optionIndex };
        });
        Object.keys(toggleLabels).forEach(function (label) {
          var idx = toggleLabels[label].optionIndex;
          var selectedBtn = customWrap.querySelector(
            '.custom-builder__opt-btn[data-type="toggle"][data-label="' + label + '"].is-selected'
          );
          if (!selectedBtn) return;
          if (!selectedBtn.dataset.variantId) {
            mainProps[label] = 'なし';
          } else if (selectedBtn.dataset.hasInput === 'true') {
            var inputEl = document.getElementById('option-text-' + idx + '-' + productId);
            var text = inputEl ? inputEl.value.trim() : '';
            mainProps[label] = text ? 'あり「' + text + '」' : 'あり';
          } else {
            mainProps[label] = 'あり';
          }
        });

        customWrap.querySelectorAll('.custom-builder__select--paid').forEach(function (sel) {
          var label = sel.dataset.label;
          if (!label) return;
          var selectedOption = sel.options[sel.selectedIndex];
          mainProps[label] = selectedOption && sel.value ? selectedOption.dataset.choiceLabel : '選択なし';
        });

        customWrap.querySelectorAll('.custom-builder__opt-btn.is-selected[data-type="toggle"]').forEach(function (btn) {
          var vid = btn.dataset.variantId;
          if (!vid) return;
          var props = { _bundle_id: bundleId, _is_main: 'false' };
          if (btn.dataset.hasInput === 'true') {
            var inputEl = document.getElementById('option-text-' + btn.dataset.optionIndex + '-' + productId);
            var text = inputEl ? inputEl.value.trim() : '';
            if (text) {
              props['刻印内容'] = text;
              props[btn.dataset.label + '内容'] = text;
            }
          }
          items.push({ id: Number(vid), quantity: 1, properties: props });
        });

        customWrap.querySelectorAll('.custom-builder__select--paid').forEach(function (sel) {
          var vid = sel.value;
          if (!vid) return;
          var selectedOption = sel.options[sel.selectedIndex];
          items.push({
            id:       Number(vid),
            quantity: 1,
            properties: {
              _bundle_id:      bundleId,
              _is_main:        'false',
              _display_label:  sel.dataset.label,
              _display_choice: selectedOption ? selectedOption.dataset.choiceLabel : ''
            }
          });
        });
      }

      ['single', 'a', 'b'].forEach(function (ring) {
        selections[ring].forEach(function (sel, idx) {
          if (!sel.subVariantId) return;
          var prefix = ring === 'single' ? '' : 'RING ' + ring.toUpperCase() + ' ';

          var choiceLabel = '';
          if (sel.isBirthstone) {
            var selectEl = document.querySelector(
              '.motif-builder__sub-select[data-handle="' + sel.handle + '"][data-index="' + idx + '"]'
            );
            if (selectEl) {
              var opt = selectEl.options[selectEl.selectedIndex];
              choiceLabel = opt ? (opt.dataset.choiceLabel || '') : '';
            }
          } else {
            var subBtnEl = document.querySelector(
              '.motif-builder__sub-btn.is-selected[data-handle="' + sel.handle + '"][data-index="' + idx + '"]'
            );
            choiceLabel = subBtnEl ? (subBtnEl.dataset.choiceLabel || '') : '';
          }

          items.push({
            id:       Number(sel.subVariantId),
            quantity: 1,
            properties: {
              _bundle_id:      bundleId,
              _is_main:        'false',
              _display_label:  prefix + sel.label,
              _display_choice: choiceLabel
            }
          });
        });
      });

      try {
        var res = await fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ items: items })
        });

        if (!res.ok) {
          var errData = await res.json().catch(function () { return {}; });
          throw new Error(errData.description || 'カートへの追加に失敗しました');
        }

        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('.cart-count-bubble span').forEach(function (el) {
              el.textContent = cart.item_count;
            });
          });

        submitBtn.textContent = '追加しました ✓';
        setTimeout(function () {
          submitBtn.disabled    = false;
          submitBtn.textContent = originalText;
        }, 2000);

      } catch (err) {
        alert(err.message);
        submitBtn.disabled    = false;
        submitBtn.textContent = originalText;
      }
    }

    // ── 初期化 ────────────────────────────────────────────
    updateTotalPrice();
    prefetchMotifs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();